import { ConfluenceLogo } from '@atlaskit/logo';
import {
  backgroundWithSideImages,
  CobrandingComponents,
} from '../../../../components/whitebox-cobranding/shared-cobranding';
import defaultImageLeft from '../../../../images/cobranding/default/default_left.svg';
import defaultImageRight from '../../../../images/cobranding/default/default_right.svg';

export const DefaultCobrandingBackground = backgroundWithSideImages(
  defaultImageLeft,
  defaultImageRight
);

const AdminExperimentForConfluence: CobrandingComponents = {
  background: DefaultCobrandingBackground,
  logo: { component: ConfluenceLogo },
  footerProducts: 'Jira, Confluence, Trello',
};

export default AdminExperimentForConfluence;
